import { Label, LabelSize } from '@ets/design-system';
import { useGetElementStatusListQuery } from '_common/services/api/elementStatusApi';

type StatusProps = {
  id: ObjectId;
  fullWidth?: boolean;
  size: LabelSize;
  testId: string;
};

/**
 * Renders the status badge
 */
const Status = ({ id, fullWidth = false, size = 's', testId }: StatusProps) => {
  const { status } = useGetElementStatusListQuery(undefined, {
    selectFromResult: ({ data }) => ({ status: data?.entities[id] }),
  });

  if (status) {
    return (
      <Label variant={status.color} fullWidth={fullWidth} size={size} testId={testId}>
        {status.name}
      </Label>
    );
  }

  return null;
};

export default Status;
